module.exports = __webpack_public_path__ + "static/img/bags.748bf7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/bags.jpg
// module id = IWUy
// module chunks = 1